import { Injectable } from '@angular/core';

import { AbstractAsyncTaskReport } from './abstract-async-task.report';
import { ITask } from './async-task-constants';
import { isArray } from '@core/helpers';

interface ITabError {
  error_type: string;
  error_detail: string[];
}
interface IMultiTabError {
  attachment_id: number;
  error_detail: Record<number, ITabError[]>;
  error_type: string;
}

@Injectable({
  providedIn: 'root'
})
export class CatoNetworkLinesImportReport extends AbstractAsyncTaskReport {

  public generate(task: ITask): string {
    if (task.status === 'success') {
      let htmlDetail = `<div>Import des équipements cato réussi.<br></div>`;
      htmlDetail += this.formatCatoNetworkDeviceImportSuccess(task.detail);
      return htmlDetail;

    } else {
      let htmlDetail = `<div>Échec de l'import des équipements cato.<br></div>`;
      htmlDetail += this._formatMultiTabImportError(task.detail, {
        INVALID_FILE_CONTENT: this._handleMultiTabContentErrors.bind(this),
        INVALID_FILE_STRUCTURE: this._handleFileStructureErrors.bind(this),
        MISSING_REFERENCES: this._handleMissingReference.bind(this),
        ND_CATO_ALREADY_EXIST_WITH_THIS_NAME: this._handleCatoImportError.bind(this),
        CATO_NETWORK_DEVICES_IMPORT_ERROR: this._handleCatoNetworkDevicesImportError.bind(this),  // ← ajout
      });
      return htmlDetail;
    }
  }

  private formatCatoNetworkDeviceImportSuccess(detail): string {
    if (!detail) {
      return '';
    }
    const downloadUrl = this.apiShiva.attachments.downloadUrl(detail.attachment_id);
    return `
      ${detail.detail}<br><br>
      <ul>
        <li>
          <a href="${downloadUrl}" class="btn btn-default" target="_blank">
            <i class="far fa-file-excel" aria-hidden="true"></i>
            Télécharger le rapport
          </a>
        </li>
      </ul>
    `;
  }

  private _handleCatoImportError(error): string {
    let errorString = `Erreur interne lors de l'import cato :<br>`;
    errorString += `<ul><li>Plusieurs équipements porteront le même nom à la suite de l'import, veuillez faire le nécessaire.</li></ul>`;
    return errorString;

  }

  private _handleMissingReference(error): string {
    let errorString = `Références manquantes :<br>`;
    errorString += `<ul><li>` + error.error_detail + `</li></ul>`;
    return errorString;
  }

  private _handleFileStructureErrors(error): string {
    let errorString = `Structure du fichier importé invalide :<br>`;
    errorString += `<ul>`;
    if (error && isArray(error)) {
          errorString += `<ul><li>`;
          errorString += error[0]?.error_detail.join('</li>\n<li>');
          errorString += `</li></ul>`;
    }
    return errorString;
  }

  private _handleMultiTabContentErrors(error: IMultiTabError): string {
    let errorString = `Certains onglets n'ont pas passé l'étape de validation.`;
    errorString += `<ul>`;
    errorString += Object.keys(error.error_detail).map((tabIndex: string) => {
      const tabNumber: number = parseInt(tabIndex, 10) + 1;
      return `<li>Onglet ${tabNumber}</li>`;
    });
    errorString += `
      </ul>
      <br><br>
      <a href="${this.apiShiva.attachments.downloadUrl(error.attachment_id)}" class="btn btn-default" target="_blank">
        <i class="far fa-file-excel" aria-hidden="true"></i>
        Télécharger le rapport
      </a>
    `;
    return errorString;
  }

  private _handleCatoNetworkDevicesImportError(error): string {
    let errorString = `Une erreur est survenue lors de l'import des équipements réseau Cato :<br>`;
    if (error?.error) {
      errorString += `<ul><li>${error.error}</li></ul>`;
    }
    return errorString;
  }
  protected _formatMultiTabImportError(detail: IMultiTabError, additionalErrorHandling: Record<string, (error: any) => string> = {}): string {
    const errorHandlerMap = this.getErrorHandlerMap(additionalErrorHandling);

    let error_type = detail.error_type;
    if (detail && isArray(detail)) {
      error_type = detail[0].error_type;
    }

    let errorHandler = errorHandlerMap[error_type];
    if (!errorHandler) {
      errorHandler = () => 'Erreur non reconnue.';
    }

    return`<ul>
        <li>${errorHandler(detail)}</li>
    </ul>`;
  }
}
